import type { FormControl } from "./actions-reducer";
import api from "api/api";
import { getToken, removeToken } from "Session";
import {
  LoginUserDataProps,
  UserActions
} from "../types/application-context-types";
import { apiJWT } from "api/api-jwt";
import type { Router } from "router-manager/parts";

export const INITIAL_ATTENDANCE_VALUES: FormControl = {
  values: {},
  initialValues: {},
  pendingChanges: false,
  invalidFields: [],
  isExtratoCopiado: false
};

interface LoginParams {
  setUserAction: (action: UserActions) => void;
  router: any;
  thisRouter: string | null;
}

export const autoLogin = async ({
  setUserAction,
  router,
  thisRouter
}: LoginParams) => {
  try {
    const token = getToken();
    const response = await api.get<LoginUserDataProps>("/usuarios/login", {
      headers: { Authorization: `Basic ${token}` }
    });
    let tokenPayload: any;
    try {
      // Try to decode access token
      tokenPayload = apiJWT.getTokenPayload() || null;
    } catch (e) {
      await apiJWT.refreshToken();
      tokenPayload = apiJWT.getTokenPayload() || null;
    }

    const userData = { ...response.data, ...tokenPayload };

    setUserAction({
      type: "login",
      payload: { token: token!, userData }
    });
  } catch {
    removeToken();
    router.push({
      pathname: "/login",
      payload: { prevPath: thisRouter }
    });
  } finally {
    setUserAction({ type: "logging", payload: false });
  }
};
